<template>
<div>

  <a v-if="isModal" class=" text-decoration-none text-black" :href="buttonUrl">
    <button @click="confirmToRegister" class="btn-landing border-0" :class="classButton">
      <img v-if="imageUrl" :src="imageUrl" alt="">
          {{title}}
    </button>
  </a>
  <a v-else class=" text-decoration-none text-black" :href="buttonUrl">
    <button class="btn-landing border-0" :class="classButton">
      <img v-if="imageUrl" :src="imageUrl" alt="">
          {{title}}
    </button>
  </a>
 <confirm-modal ref="confirmModal"/>
</div>
</template>

<script>
import confirmModal from '../reusablecomponent/confirmModal.vue'
 export default {
    props:['title' , 'classButton' , 'imageUrl','buttonUrl'],
    props:{
      title:{
        default:"",
        type:String,
      },
      classButton:{
        default:"",
        type:String,
      },
      imageUrl:{
        default:"",
        type:String,
      },
      buttonUrl:{
        default:"",
        type:String,
      },
      isModal:{
        type: Boolean,
        default: false,
      }
    },
    components:{
      confirmModal
    },
    methods:{
      confirmToRegister(){
          this.$refs.confirmModal.openModal();
       }
    }
}
    window.onload = function() {
         var anchorTags = document.querySelectorAll('a[href="#confirmButton"]');

         anchorTags.forEach(function(anchor) {
             anchor.addEventListener('click', function(event) {
                 event.preventDefault();
            });
        });
    };
</script>

<style scoped>

</style>